import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=388aeb6a&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=388aeb6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388aeb6a",
  null
  
)

export default component.exports